import React, {FunctionComponent, useState} from "react";
import {makeStyles} from "tss-react/mui";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SettingsIcon from "@mui/icons-material/Settings";
import {DRAWER_WIDTH, DRAWER_WIDTH_CLOSED} from "@/Components/Sidebar/Constants";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import {useHistory, useLocation} from "react-router-dom";
import Logo from "@/Style/crentweb-logo.png";
import {CLOSE_SIDEBAR, OPEN_SIDEBAR} from "@/Redux/App/AppConstants";
import {Drawer, FormControlLabel, ListItemButton, Theme,} from "@mui/material";
import {useAppDispatch, useAppSelector} from "@/Redux/Redux";
import _ from "lodash";
import {AUTH_LOGOUT_SAGA} from "@/Redux/Auth/AuthConstants";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import {CHANGE_STATION_START} from "@/Redux/Disposition/Constants";
import {RootStateOrAny, useSelector} from "react-redux";
import {selectViewerEnabledStations, ViewerState,} from "@/Redux/Auth/AuthReducer";
import MuiSelect from "@mui/material/Select";
import MenuDisposition from "@/Components/Sidebar/SidebarV2/Components/MenuDisposition";
import MenuGeneralData from "@/Components/Sidebar/SidebarV2/Components/MenuGeneralData";
import MenuProcesses from "@/Components/Sidebar/SidebarV2/Components/MenuProcesses";
import Icon from '@mdi/react';
import {mdiMenuClose, mdiMenuOpen} from '@mdi/js';
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";
import {selectParameters} from "@/Redux/App/AppReducer";
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import CampaignIcon from '@mui/icons-material/Campaign';
import {WhatsNewModal} from "@/Components/WahtsNewModal/WhatsNewModal";

interface SidebarProps {
    viewData?: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    drawerOpen: {
        width: DRAWER_WIDTH,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: 0,
        }),
    },

    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: 0,
        }),
        overflowX: "hidden",
        width: DRAWER_WIDTH_CLOSED,
    },

    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        //...theme.mixins.toolbar,
    },
    customerLogo: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    listItem: {
        color: "#fff",
    },
    listItemIcon: {
        color: "#fff !important",
    },
    fixedBottom: {
        right: 0,
        left: 0,
        bottom: 0,
        zIndex: 1030,
    },
    crwLogo: {
        padding: ".5rem 1.25rem",
        textAlign: "center",
    },
    version: {
        width: "100%",
        marginBottom: 10,
        textAlign: "center",
        fontSize: "12px"
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    active: {
        backgroundColor: "#e42022!important",
        borderColor: "#e42022!important",
        fontWeight: 600,
    },
    select: {
        paddingTop: 0,
        paddingBottom: 0,

        color: "white",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "white !important",
        },
        "& .MuiNativeSelect-icon": {
            color: "white",

        },
    },
}));

const SidebarV2: FunctionComponent<SidebarProps> = ({viewData}): JSX.Element => {
    const {classes, cx} = useStyles();
    const dispatch = useAppDispatch();
    const app = useAppSelector((state) => state.app);
    const mandant = app.mandant?.data;
    const [configurationOpen, setConfigurationOpen] = useState(false);
    const [dispositionOpen, setDispositionOpen] = useState(false);
    const [whatsNewIsOpen, setWhatsNewIsOpen] = useState(false);
    const history = useHistory();
    const parameters = useSelector((state) =>
        selectParameters(state as RootStateOrAny)
    );
    const rights = viewData?.rights;

    const helpLinkParameter = parameters.data.find((parameter: any) => parameter.parameter == 'SHELP_LINK')
    const toggleDrawer = () => {
        if (app.sidebarIsOpen) {
            dispatch({type: CLOSE_SIDEBAR});
        } else {
            dispatch({type: OPEN_SIDEBAR});
        }
    };

    const location = useLocation();
    const {t} = useTranslation();

    function handleLogout() {
        dispatch({type: AUTH_LOGOUT_SAGA});
    }

    const isActive = (pathname: string, exact: boolean = false) => {
        if (exact) {
            return location.pathname === pathname;
        }
        return _.includes(location.pathname, pathname);
        //return pathname === location.pathname;
    };
    const appDispatch = useAppDispatch();
    const {selectedStation} = useAppSelector((state) => state.disposition);
    const enabledStations = useSelector((state) =>
        selectViewerEnabledStations(state as ViewerState)
    );

    const renderSelect = () => {
        return (
            <MuiSelect
                className={classes.select}
                variant={"outlined"}
                size={"small"}
                //style={{height: 'calc(1.5em + .5rem)'}}
                style={{
                    color: "white",
                    borderColor: "white !important"
                }}
                native
                sx={{
                    '& option': {
                        backgroundColor: "#2f333e !important"
                    }
                }}
                value={selectedStation || ""}
                onChange={(e) => {
                    appDispatch({
                        type: CHANGE_STATION_START,
                        payload: e.target.value,
                    });
                }}
            >
                {enabledStations
                    .filter(
                        (station: any) => station.isChangeableInDispo == "J"
                    )
                    .map((station: { stationId: string; name: string }) => (
                        <option
                            key={station.stationId}
                            value={station.stationId}
                        >
                            {station.stationId} - {station.name}
                        </option>
                    ))}
            </MuiSelect>
        );
    };

    return (
        <>
            <Drawer
                transitionDuration={0}
                id="sidebar"
                variant="permanent"
                className={cx({
                    [classes.drawerOpen]: app.sidebarIsOpen,
                    [classes.drawerClose]: !app.sidebarIsOpen,
                })}
                classes={{
                    paper: cx({
                        [classes.drawerOpen]: app.sidebarIsOpen,
                        [classes.drawerClose]: !app.sidebarIsOpen,
                    }),
                }}
            >
                <div className={classes.toolbar}>
                    <IconButton
                        className={classes.listItemIcon}
                        onClick={toggleDrawer}
                    >
                        {!app.sidebarIsOpen ? (
                            <Icon path={mdiMenuClose} size={1.5}/>

                        ) : (
                            <Icon path={mdiMenuOpen} size={1.5}/>
                        )}
                    </IconButton>
                </div>
                <div className={classes.customerLogo}>
                    {app.initialized && app.sidebarIsOpen && (
                        <img
                            className="mand-menu-collapsed"
                            src={mandant?.logo + "&timestamp=" + new Date().getUTCMilliseconds().toString()}
                            alt="Mandant Logo"
                            style={{width: "100%"}}
                            ref={(img) => {
                                if (!img) {
                                    return;
                                }

                                const check = () => {
                                    if (img.complete && img.naturalWidth > 0) {
                                        img.style.display = "block";
                                    } else {
                                        img.style.display = "none";
                                    }
                                };

                                if (img.complete) {
                                    check();
                                } else {
                                    img.onload = check;
                                }

                                img.onerror = check;
                            }}
                        />
                    )}
                </div>
                <FormControlLabel
                    style={{
                        fontSize: ".875rem !important",
                        color: "white",
                    }}
                    control={renderSelect()}
                    label={t("sidebar.rentalAtStation")}
                    labelPlacement={"top"}
                />
                <Divider/>
                <List>
                    <MenuDisposition/>
                    <Divider/>
                    <MenuGeneralData/>
                    <Divider/>
                    <MenuProcesses viewData={viewData}/>

                    {rights?.find(
                        (right: any) => right.right === "ABF_ALLE",
                    ) && <ListItemButton
                      dense
                      key={"queries"}
                      className={cx(
                          classes.listItem,
                          isActive("/manager/queries") ? classes.active : ""
                      )}
                      onClick={() => {
                          history.push("/manager/queries");
                      }}
                    >
                      <ListItemIcon className={classes.listItemIcon}>
                        <QuestionMarkIcon/>
                      </ListItemIcon>
                      <ListItemText primary={t("sidebar.queries")}/>
                    </ListItemButton>}
                </List>

                <div
                    className={classes.fixedBottom}
                    style={{
                        position: configurationOpen ? "sticky" : "absolute",
                        top: configurationOpen ? "100%" : "auto",
                    }}
                >
                    <List>
                        <ListItemButton
                            dense
                            data-testid={"sidebar-configuration-button"}
                            key={"configuration"}
                            data-testid={"sidebar-configuration-button"}
                            className={cx(
                                classes.listItem,
                                isActive("/configuration") ? classes.active : ""
                            )}
                            onClick={() => {
                                history.push("/manager/configuration/dashboard");
                            }}
                        >
                            <ListItemIcon className={classes.listItemIcon}>
                                <SettingsIcon/>
                            </ListItemIcon>
                            <ListItemText primary={t("sidebar.configure")}/>
                        </ListItemButton>
                        <ListItemButton
                            dense
                            key={"whatsnew"}
                            className={cx(
                                classes.listItem
                            )}
                            onClick={() => {
                                setWhatsNewIsOpen(true);
                            }}
                        >
                            <ListItemIcon className={classes.listItemIcon}>
                                <CampaignIcon/>
                            </ListItemIcon>
                            <ListItemText primary={t("sidebar.whatsnew", "Was ist neu?")}/>
                        </ListItemButton>
                        {helpLinkParameter?.value && <ListItemButton
                          dense
                          data-testid={"sidebar-help-button"}
                          key={"help"}
                          className={cx(
                              classes.listItem,
                              isActive("/help") ? classes.active : ""
                          )}
                          onClick={() => {
                              window.open(helpLinkParameter?.value, "_blank")
                          }}
                        >
                          <ListItemIcon className={classes.listItemIcon}>
                            <HelpCenterOutlinedIcon/>
                          </ListItemIcon>
                          <ListItemText primary={t("sidebar.help")}/>
                        </ListItemButton>}
                        <ListItemButton
                            dense
                            key={"logout"}
                            className={classes.listItem}
                            onClick={handleLogout}
                        >
                            <ListItemIcon className={classes.listItemIcon}>
                                <ExitToAppOutlinedIcon/>
                            </ListItemIcon>
                            <ListItemText primary={t("sidebar.logout")}/>
                        </ListItemButton>
                    </List>
                    <div className={classes.crwLogo}>
                        {app.sidebarIsOpen && (
                            <img
                                className="mand-menu-collapsed"
                                src={Logo}
                                alt="CRW Logo"
                                style={{width: "100%"}}
                            />
                        )}
                    </div>
                    <div className={classes.version}>
                        <p style={{margin: 0}}>
                            {t("sidebar.version")} {!app.sidebarIsOpen && <br/>}{" "}
                            {import.meta.env.VITE_VERSION}
                        </p>
                    </div>
                </div>
            </Drawer>
            {whatsNewIsOpen && <WhatsNewModal onClose={() => {
                setWhatsNewIsOpen(false)
            }}/>}
        </>
    );
};

export default SidebarV2;
